export const stripLineFromSellerName = (seller: string) => {
  return seller.split("\\").pop() ?? "";
};
